import { FC, useState, Fragment, useMemo, useRef, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import { useRequest, useSafeState, useLockFn } from 'ahooks';
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSpring, animated } from '@react-spring/web'
import { Loader, Panel, Alert, HelpHead } from '../components'
import { getArticleDetail } from '../api'
import remarkGfm from 'remark-gfm'
import dayjs from 'dayjs'
import numeral from 'numeral'


type DetailData = {
  content: string;
  create_time: string;
  id: number;
  title: string;
  update_time: string;
}

export const HelpDetail = () => {
  const params = useParams();

  const { data, error, loading } = useRequest<any, any>(() => {
    return getArticleDetail(params?.id)
  }, {
    refreshDeps: [(params?.id ?? 0)],
    staleTime: -1,
    cacheTime: -1,
    cacheKey: `cacheKey-helplist${params?.id}`,
  });
  const result = useMemo<DetailData>((): DetailData => {
    if (loading) {
      return {} as DetailData
    }
    return (data?.data ?? {}) as DetailData
  }, [data?.data, loading])



  return (
    <div className="h-full min-h-screen bg-darkbg">
      <HelpHead title="帮助详情" />
      <div className="flex flex-col">
        {
          loading ? null : (
            <>
              <div className="py-4 mx-4  text-white text-opacity-90 text-base border-b border-b-white/5 flex justify-between">
                <div className="flex gap-2 items-center ">
                  <span className="w-1 h-3 bg-orange-secondary-gradient rounded"></span>
                  {result?.title}
                </div>
              </div>

              <div className="text-white py-3 px-4 text-opacity-80 text-sm md">
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  children={String(result?.content).replace(/\n$/, '')}
                />
              </div>
            </>
          )
        }

      </div>
    </div>

  )
}
